module.exports = __webpack_public_path__ + "static/media/techno.a7b35489.jpg";